<mat-toolbar color="primary">
    <span class="title-center">{{title}}</span>
</mat-toolbar>
<div align="center" fxLayout="column" class="m-content">
    <form [formGroup]="externalRequestForm" fxLayout="column"
        fxLayoutGap="15px">
        <mat-card fxLayout="column">
            <mat-form-field>
                <input type="text" matInput placeholder="Request Number"
                    formControlName="requestNumber" readonly>
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput placeholder="{{this.type !== 'PP' ?
                    'Project Name' : 'Request Name'}}"
                    formControlName="requestName" readonly>
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput maxlength="50" placeholder="Comment"
                    formControlName="comment">
            </mat-form-field>
            <mat-form-field>
                <input DecimalTrail formControlName='amount'
                    [readonly]="!isAwardedAmountEditable"
                    placeholder="Amount Awarded" maxlength="12"
                    formControlName="amount" matInput type="text"
                    [required]='[9].includes(externalRequestForm.value.statusId)'>
            </mat-form-field>
        </mat-card>
        <mat-card fxLayout="column" *ngIf="isShowAccDist">
            <div class="table-container">
                <table formArrayName="AccDistribution">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Company {{isRequired === true ? ' *' : ''}}
                            </th>
                            <th>Project {{isRequired === true ? ' *' : ''}}
                            </th>
                            <th>Task {{isRequired === true ? ' *' : ''}} </th>
                            <th>Exp-Type {{isRequired === true ? ' *' : ''}}
                            </th>
                            <th>Exp-Org {{isRequired === true ? ' *' : ''}}
                            </th>
                            <th>Amount {{isRequired === true ? ' *' : ''}} </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr [formGroupName]="i"
                            *ngFor="let accDist of
                            externalRequestForm.get('AccDistribution')['controls'];
                            let i= index">
                            <td>{{ i+1 }}</td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="company"
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'company')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let company of
                                            companyData[i]"
                                            [value]="company.code">
                                            {{company.descr}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="project"
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'project')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let project of
                                            projectData[i]"
                                            [value]="project.project">
                                            {{project.project}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="task"
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'task')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let task of
                                            taskData[i]" [value]="task.task">{{task.task}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="expType"
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'expType')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let expType of
                                            expTypeData[i]"
                                            [value]="expType.code">
                                            {{expType.code}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="expOrg"
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'expOrg')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let expOrg of
                                            expOrgData[i]"
                                            [value]="expOrg.code">
                                            {{expOrg.code}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <input DecimalTrail style="text-align:
                                        center;" type="text" matInput
                                        (input)="calculateTotalAmount()"
                                        maxlength="12" formControlName="amount">
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td style="text-align: center;">
                                <b>Total Awarded Amount:</b>
                            </td>
                            <td style="text-align: center;">
                                <span>
                                    <b>$ {{externalRequestForm.value.amount}}</b>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-card>
    </form>
    <div style="margin-top: 10px; text-align: center;">
        <button mat-raised-button (click)="onNoClick()" color="warn">Skip</button>
        <button mat-raised-button color="primary"
            [disabled]="externalRequestForm.invalid" (click)="onSave()">Save and
            Next</button>
    </div>
</div>